import Page from 'pages/Page';
import {
  importAddToCartChunks,
  importAlertChunks,
  importScrollToTopChunks,
} from '../../components/Cart/Chunks/Chunks';
import MediaQueries from '../../shared/helpers/MediaQueries';
import WishlistChunk from '../../modules/InitChunks/WishlistChunk/WishlistChunk';
import searchChunk from '../../../../../assets/js/modules/search/searchChunk';

export default class Search extends Page {
  constructor() {
    super();

    /*
     * Primary script
     * */
    window.addEventListener(
      'load',
      () => {
        /* Import old chunk search */
        // eslint-disable-next-line new-cap
        new searchChunk();

        // Add to cart
        importAddToCartChunks();

        // Alert
        importAlertChunks();

        // Add Wishlist
        WishlistChunk();
      },
      { once: true, passive: true }
    );

    /*
     * Secondary script
     * */
    if (MediaQueries.mobileMedia.matches) {
      // Load files for Mobile
      document.addEventListener(
        'touchstart',
        () => {
          this.importsChunks();
        },
        { once: true, passive: true }
      );
    } else {
      // Load files for other
      this.importsChunks();
    }
  }

  private importsChunks(): void {
    // Scroll To Top
    importScrollToTopChunks();
  }
}

new Search();
